'use client';

import { Alert } from '@/app/components/icons/Alert';
import { ErrorIcon } from '@/app/components/icons/ErrorIcon';
import { SuccessIcon } from '@/app/components/icons/SuccessIcon';
import { cn } from '@/app/utils';
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from './toast';
import { useToast } from './use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider swipeDirection="up">
      {toasts.map(
        ({
          id,
          title,
          message,
          action,
          variant,
          icon,
          containerClassName = '-translate-x-1/2 absolute top-24 left-1/2',
          contentClassName,
          titleClassName,
          closeClassName,
          closable = false,
          ...props
        }) => {
          return (
            <Toast key={id} {...props} className={containerClassName}>
              <div className="grid gap-1">
                {title && <ToastTitle className={titleClassName}>{title}</ToastTitle>}
                {message && (
                  <ToastDescription className={cn('flex items-center gap-2', contentClassName)}>
                    {variant === 'warning' && <Alert className="flex-shrink-0 text-system-warning text-xl" />}
                    {variant === 'error' && <ErrorIcon className="flex-shrink-0 text-system-error1 text-xl" />}
                    {variant === 'success' && <SuccessIcon className="flex-shrink-0 text-system-success text-xl" />}
                    {variant === 'custom' && icon}
                    {message}
                  </ToastDescription>
                )}
              </div>
              {action}
              {closable && <ToastClose className={closeClassName} />}
            </Toast>
          );
        },
      )}
      <ToastViewport />
    </ToastProvider>
  );
}
